<template>
<div>
	<div class="d-flex flex-row align-items-center justify-content-between">

		<h2>Maintenance Schedule</h2>

		<div v-if="$route.params.slug != 'new' && equipmentItem.archived == 0">
			<button class="btn btn-success" v-on:click="newMaintenanceScheduleEvent">
				<i class="fa fa-plus"></i>
				Add Event
			</button>
		</div>
	</div>

	<table-list
		record-name="Maintenance Event"
		:records="mutatedMaintenanceScheduleEvents"
		:fields="[
			{label: 'Event', key: 'title'},
			{label: 'Due Date', key: 'due_date'},
			{label: odoUnits, key: 'mileage_or_time',align:'right'}
		]"
		:has-edit="true"
		:sortable="true"
		:has-delete="equipmentItem.archived == 0"
		delete-endpoint="EquipmentMaintenanceEventReminder/delete"
		:hide-record-count="true"
		id-field="slug"
		v-on:modelChange="fetchMaintenanceEvents"
		v-on:edit="editMaintenanceScheduleEvent">
	</table-list>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		:working="editModal.working"
		confirm-button-text="Save"
		:cancel-button-text="editModal.cancelButtonText"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveEntry">

		<field label="Event Type"
			col-class="col-md-4"
			:params="{
				type: 'select',
				options: filteredEventTypeOptions
			}"
			v-model="editModal.payload.event_id">
		</field>

		<field label="Due Date"
			col-class="col-md-4"
			:params="{
				type: 'date',
			}"
			v-model="editModal.payload.due_date">
		</field>

		<field :label="odoUnits"
			col-class="col-md-4"
			:params="{
				type: 'number',
				step: 0.1,
				min: 0
			}"
			v-model="editModal.payload.mileage_or_time">
		</field>

		<template slot="footer">
			<button v-if="editModal.payload.event_id" class="btn btn-dark" type="button" v-on:click="convertToMaintenanceLog">
				Convert to Maintenance Log...
			</button>
		</template>

	</modal-dialog>

	<equipment-maintenance-log-edit-modal :record="logEditModal.record"
		:visible="logEditModal.visible"
		:equipment-item="equipmentItem"
		:readonly="false"
		v-on:saved="editModal.cancelButtonText = 'Done'"
		v-on:closeModal="logEditModal.visible = false">
	</equipment-maintenance-log-edit-modal>
</div>
</template>
<script type="text/javascript">

import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import EquipmentMaintenanceLogEditModal from "@/components/super_components/EquipmentMaintenanceLogEditModal"

export default {
	name: "EquipmentItemMaintenanceSchedule",
	components: {
		Field,
		TableList,
		ModalDialog,
		EquipmentMaintenanceLogEditModal
	},
	props: ["equipmentItem"],
	data() {
		return {
			maintenanceScheduleEvents: [],
			eventTypes: [],
			eventTypeCategories: [],
			openRecordOnLoad: false,
			editModal: {
				visible: false,
				title: "New Maintenance Schedule Entry",
				payload: {},
				working: false,
				cancelButtonText: "Cancel"
			},
			logEditModal: {
				visible: false,
				record: null
			}
		}
	},
	watch: {
		equipmentItem() {
			if (this.equipmentItem && "id" in this.equipmentItem) {
				this.fetchMaintenanceEvents()

				if ("tabRecordSlug" in this.$route.params && this.$route.params.tab == 'maintenance-schedule')
					this.openRecordOnLoad = this.$route.params.tabRecordSlug
			}
		}
	},
	computed: {
		odoUnits() {
			let unit = "KM"
			if ("EquipmentType" in this.equipmentItem && this.equipmentItem.EquipmentType) {
				if ("odo_unit" in this.equipmentItem.EquipmentType && this.equipmentItem.EquipmentType.odo_unit)
					unit = this.equipmentItem.EquipmentType.odo_unit
			}

			return unit
		},
		mutatedMaintenanceScheduleEvents() {
			let vm = this

			return this.maintenanceScheduleEvents.map(event => {
				event.title = event.EquipmentMaintenanceEventType.title

				return event
			})
		},
		filteredEventTypeOptions() {
			return this.optionify(this.eventTypes.filter(eventType => {
				if (eventType.EquipmentType.find(type => type.id == this.equipmentItem.type_id))
					return true
				else if (!eventType.EquipmentType || eventType.EquipmentType.length == 0)
					return true
			}),"title")
		}
	},
	methods: {
		newMaintenanceScheduleEvent() {
			this.editModal.visible = true
			this.editModal.title = "New Maintenance Schedule Entry"
			this.editModal.cancelButtonText = "Cancel"
			this.editModal.payload = {
				due_date: null,
				event_id: null,
				equipment_id: this.equipmentItem.id
			}

			if (this.eventTypes.length == 0)
				this.fetchEventTypes()
		},
		editMaintenanceScheduleEvent(record) {
			this.editModal.visible = true
			this.editModal.title = "Edit Maintenance Schedule Entry"
			this.editModal.cancelButtonText = "Cancel"
			this.editModal.payload = {
				due_date: record.due_date,
				event_id: record.event_id,
				id: record.id,
				equipment_id: this.equipmentItem.id
			}

			if (this.eventTypes.length == 0)
				this.fetchEventTypes()
		},
		saveEntry() {
			let vm = this

			this.editModal.working = true

			this.postData("EquipmentMaintenanceEventReminder/save",this.editModal.payload,true).then(response => {
				this.editModal.working = false

				if (response.success) {
					vm.fetchMaintenanceEvents()
					vm.editModal.visible = false
				}
			})
		},
		convertToMaintenanceLog() {
			let eventType = this.eventTypes.find(eventType => eventType.id == this.editModal.payload.event_id)

			let workDone = ""
			if (eventType) {
				workDone = "Completed " + eventType.title

				if (eventType.description)
					workDone += ": " + eventType.description
			}

			let populatedRecord = {
				equipment_slug: this.equipmentItem.slug,
				date_done: this.moment().format("YYYY-MM-DD"),
				work_done: workDone,
				EquipmentMaintenanceEventType: [this.editModal.payload.event_id]
			}

			let category = this.eventTypeCategories.find(cat => cat.id == eventType.category_id)
			if (category) 
				populatedRecord.type = category.name

			this.logEditModal.visible = true
			this.logEditModal.record = populatedRecord

		},
		fetchEventTypes() {
			let vm = this

			this.getJSON("EquipmentMaintenanceEventType/get",{include: [{model: "EquipmentType",fields:["id","slug","odo_unit"]}]}).then(response => {
				if (response.success)
					vm.eventTypes = response.data
			})

			this.getJSON("EquipmentMaintenanceEventType/categories").then(response => {
				if (response.success)
					vm.eventTypeCategories = response.data
			})
		},
		fetchMaintenanceEvents() {
			let vm = this

			let params = {
				filters: [
					["equipment_id",this.equipmentItem.id]
				],
				include: [
					{
						model: "EquipmentMaintenanceEventType",
						fields: ["title"]
					}
				]
			}

			this.getJSON("EquipmentMaintenanceEventReminder/get",params).then(response => {
				if (response.success) {
					vm.maintenanceScheduleEvents = response.data

					if (vm.openRecordOnLoad) {
						let recordToOpen = vm.maintenanceScheduleEvents.find(event => event.slug == vm.openRecordOnLoad)
						vm.editMaintenanceScheduleEvent(recordToOpen)
						vm.openRecordOnLoad = false
					}
				}
			})
		}
	},
	created() {
		if (this.equipmentItem && "id" in this.equipmentItem)  {
			this.fetchMaintenanceEvents()

			if ("tabRecordSlug" in this.$route.params && this.$route.params.tab == 'maintenance-schedule')
				this.openRecordOnLoad = this.$route.params.tabRecordSlug
		}
	}
}
</script>